import React from "react";

class Paginator extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentPage: 0 };
  }

  onPageButtonClick(direction) {
    const newPage = this.state.currentPage + direction;

    if (newPage < 0) return;
    if (newPage >= this.props.totalPages) return;

    this.setState({ currentPage: newPage });

    if (this.props.onNavigate) this.props.onNavigate(newPage);
  }

  render() {
    return (
      <div className="Paginator">
        <p className="Float-Left">{this.props.info}</p>
        <p className="Float-Right">
          Seite {this.state.currentPage + 1} von {this.props.totalPages}
        </p>
        <span>
          <p className="Link" onClick={() => this.onPageButtonClick(-1)}>
            Vorherige Seite
          </p>
          <p className="Link" onClick={() => this.onPageButtonClick(1)}>
            Nächste Seite
          </p>
        </span>
      </div>
    );
  }
}

export default Paginator;



// WEBPACK FOOTER //
// ./src/components/Paginator.js